import Account from '../Account'
import LanguageSwitch from '../LanguageSwitch'
import Polling from '../Polling'
import ThemeSwitch from '../ThemeSwitch'
import { Dropdown } from './Dropdown'

/**
 * @return {JSX.Element} Upper Navigation Bar
 */
export default function UpperNav() {
  return (
    <div className={`w-full h-[44px] py-1 duration-500 ease-in-out delay-300  bg-uppernavbar`}>
      <div className="grid items-center w-full min-w-full grid-flow-col p-0 m-0 ">
        <Polling />
        {/* <div className='absolute right-0'>
            + BCH + FIRE + EMBER PRICE
          </div>*/}

        <div className="grid justify-end grid-flow-col">
          <div className="grid justify-end grid-flow-col mr-4 sm:pl-2 sm:mr-0">
            <Account />
            <div className="p-1 sm:p-3" />
            <LanguageSwitch />
            <div className="p-1 sm:p-3" />
            <ThemeSwitch />
          </div>
          <div className="p-1 sm:p-3" />
          <Dropdown />
          <div className="p-2" />
        </div>
      </div>
    </div>
  )
}
